import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const costCodeRouteRef = createRouteRef();
export const historyRouteRef = createRouteRef();
